import React, { useState } from 'react';
import './VirtualReadingResource.css';
import Navbar from '../components/navbar';
import Footer from '../components/Footer';
import PageHeader from '../about/PageHeader';

// --- SVGs ---
const BookIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"></path></svg>;
const DownloadIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>;
const UsersIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>;
const ClockIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>;
const ChevronRight = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>;
const ExternalLinkIcon = ({ style, className }) => (
  <svg className={className} style={style} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
    <polyline points="15 3 21 3 21 9"></polyline>
    <line x1="10" y1="14" x2="21" y2="3"></line>
  </svg>
);
// --- Mapped Data from Prompt ---
// --- Mapped Data from Prompt ---
const popularSearches = ['NPTEL', 'IEEE', 'EBSCO', 'Dictionaries', 'News', 'Encyclopedias'];

const heroStats = [
  { icon: <BookIcon />, value: '4,600+', label: 'e-Books' },
  { icon: <BookIcon />, value: '103', label: 'e-Journals' },
  { icon: <UsersIcon />, value: '30+', label: 'Databases' },
  { icon: <ClockIcon />, value: '24/7', label: 'Access Anywhere' },
];

const quickStats = [
  { icon: <BookIcon />, label: 'TOTAL E-RESOURCES', value: '5,000+' },
  { icon: <DownloadIcon />, label: 'OPEN ACCESS LINKS', value: '25+' },
  { icon: <UsersIcon />, label: 'ACTIVE USERS', value: '2,845+' },
  { icon: <ClockIcon />, label: 'LAST UPDATED', value: 'Active' },
];

const newspapers = [
  { title: 'The Times of India', type: 'English Daily', color: 'blue', link: 'https://timesofindia.indiatimes.com/' },
  { title: 'The Indian Express', type: 'English Daily', color: 'red', link: 'https://indianexpress.com/' },
  { title: 'Maharashtra Times', type: 'Marathi Daily', color: 'green', link: 'https://maharashtratimes.com/' },
  { title: 'Loksatta', type: 'Marathi Daily', color: 'purple', link: 'https://www.loksatta.com/' },
  { title: 'Lokmat', type: 'Marathi Daily', color: 'blue', link: 'https://www.lokmat.com/' },
  { title: 'The Economic Times', type: 'Financial Daily', color: 'red', link: 'https://economictimes.indiatimes.com/' },
  { title: 'The Financial Express', type: 'Financial Daily', color: 'green', link: 'https://www.financialexpress.com/' },
  { title: 'The Hindu', type: 'English Daily', color: 'purple', link: 'https://www.thehindu.com/' },
  { title: 'The Employment News', type: 'Career Weekly', color: 'blue', link: 'https://employmentnews.gov.in/' },
];

const onlineResources = [
  { tag: 'COURSES', tagColor: 'purple', title: 'NPTEL', meta: 'Engineering & Science', link: 'https://nptel.ac.in/' },
  { tag: 'PLATFORM', tagColor: 'blue', title: 'SWAYAM', meta: 'Govt. Online Courses', link: 'https://swayam.gov.in/' },
  { tag: 'LIBRARY', tagColor: 'green', title: 'National Digital Library', meta: 'Digital Learning Repository', link: 'https://ndl.iitkgp.ac.in/' },
  { tag: 'THESES', tagColor: 'orange', title: 'Shodh Ganga', meta: 'Indian Theses Repository', link: 'https://shodhganga.inflibnet.ac.in/' },
  { tag: 'CONSORTIUM', tagColor: 'purple', title: 'Shodh Sindhu', meta: 'Scholarly e-Resources', link: 'https://ess.inflibnet.ac.in/' },
  { tag: 'PORTAL', tagColor: 'blue', title: 'ePathshala', meta: 'Educational Content', link: 'https://epgp.inflibnet.ac.in/' },
  { tag: 'COURSES', tagColor: 'green', title: 'MOOC', meta: 'Massive Open Online Courses', link: 'https://www.mooc.org/' },
  { tag: 'ARCHIVES', tagColor: 'orange', title: 'National Archives (NAI)', meta: 'Historical Records', link: 'https://nationalarchives.nic.in/en' },
  { tag: 'JOURNALS', tagColor: 'purple', title: 'Directory of Open Access', meta: 'DOAJ Open Journals', link: 'https://doaj.org/' },
];

const knowledgeTools = [
  { title: 'Britannica Concise', desc: 'Encyclopedia', link: 'https://www.britannica.com/', color: 'purple' },
  { title: 'Wikipedia', desc: 'Encyclopedia', link: 'https://www.wikipedia.org/', color: 'green' },
  { title: 'Columbia Encyclopedia', desc: 'Encyclopedia', link: 'https://www.infoplease.com/encyclopedia', color: 'blue' },
  { title: 'Dictionary.com', desc: 'Dictionary', link: 'https://www.dictionary.com/', color: 'purple' },
  { title: 'Phrase & Fable', desc: 'Dictionary', link: 'https://www.bartleby.com/', color: 'orange' },
  { title: 'Philosophical Terms', desc: 'Dictionary', link: 'https://www.philosophypages.com/dy/', color: 'green' },
  { title: 'Cambridge Idioms', desc: 'Dictionary', link: 'https://dictionary.cambridge.org/', color: 'blue' },
  { title: 'The Free Dictionary', desc: 'Dictionary', link: 'https://www.thefreedictionary.com/', color: 'purple' },
  { title: 'Free e-Books', desc: 'Free e-Books', link: 'https://www.free-ebooks.net/', color: 'orange' },
  { title: 'Rare Books', desc: 'Free e-Books', link: 'https://www.rarebooksocietyofindia.org/', color: 'green' },
];

const VirtualReadingResource = () => {
  
  // Pagination logic for "4 at a time"
  const [onlinePage, setOnlinePage] = useState(0);
  const itemsPerPage = 4;
  const totalOnlinePages = Math.ceil(onlineResources.length / itemsPerPage);

  const handleNextPage = () => {
    setOnlinePage((prev) => (prev + 1) % totalOnlinePages);
  };

  const handlePrevPage = () => {
    setOnlinePage((prev) => (prev - 1 + totalOnlinePages) % totalOnlinePages);
  };

  const visibleOnlineResources = onlineResources.slice(
    onlinePage * itemsPerPage,
    (onlinePage + 1) * itemsPerPage
  );

  return (
    <>
      <Navbar />
      <div className="vrr-page-wrapper">
        <PageHeader title="Virtual Reading Resource" crumbs={[{ label: "Home", href: "/" }, { label: "Virtual Reading Resource" }]} />

        <main className="vrr-container">
          
          {/* HERO SECTION */}
          <section className="vrr-hero">
            <div className="vrr-hero-left">
              <span className="vrr-hero-badge">WELCOME TO TIMSCDR</span>
              <h1>Virtual Reading Resources</h1>
              <p>Explore our subscribed databases, open educational resources, newspapers, and encyclopedias in one place.</p>
              
              {/* Search removed as requested */}
            </div>

            <div className="vrr-hero-center">
              <img src="/images/Library/hero-illustration.png" alt="Digital Reading" onError={(e) => e.target.style.display='none'} />
            </div>

            <div className="vrr-hero-right">
              {heroStats.map((stat, i) => (
                <div className="vrr-hero-stat-item" key={i}>
                  <div className="icon">{stat.icon}</div>
                  <strong>{stat.value}</strong>
                  <span>{stat.label}</span>
                </div>
              ))}
            </div>
          </section>

          {/* QUICK STATS */}
          <section className="vrr-quick-stats">
            {quickStats.map((stat, i) => (
              <div className="vrr-stat-card" key={i}>
                <div className="icon">{stat.icon}</div>
                <div className="info">
                  <span>{stat.label}</span>
                  <strong>{stat.value}</strong>
                </div>
              </div>
            ))}
          </section>

          {/* SPLIT SECTION: COLLECTIONS & NEWSPAPERS */}
          <div className="vrr-split-section">
            <div className="vrr-collections-panel">
              <div className="vrr-section-header">
                <div>
                  <h2>Subscribed Databases</h2>
                  <p>Explore our premium digital library collections</p>
                </div>
              </div>

              <div className="vrr-collections-grid">
<div className="vrr-collection-card">
                  <div className="header">
                    <div className="icon purple"><BookIcon /></div>
                    <h3>EBSCOhost-e-Book ITCore Collection</h3>
                  </div>
                  <div className="count">4,600</div>
                  <span className="sub">e-Books Available</span>
                  <p>Comprehensive ITCore collection for technology and management.</p>
                  <a href="http://search.ebscohost.com" target="_blank" rel="noreferrer" className="vrr-btn-primary">Access EBSCO <ExternalLinkIcon style={{width:'14px'}} /></a>
                </div>
<div className="vrr-collection-card">
                  <div className="header">
                    <div className="icon blue"><BookIcon /></div>
                    <h3>Springer 1 Computer Science</h3>
                  </div>
                  <div className="count">103</div>
                  <span className="sub">e-Journals Available</span>
                  <p>Access computer science e-journals from Springer.</p>
                  <a href="https://link.springer.com" target="_blank" rel="noreferrer" className="vrr-btn-primary">Access Springer <ExternalLinkIcon style={{width:'14px'}} /></a>
                </div>
              </div>
            </div>

            <div className="vrr-subjects-panel">
              <div className="vrr-section-header">
                <div>
                  <h2>Newspapers & Portals</h2>
                  <p>Stay updated with national and regional dailies</p>
                </div>
              </div>

              <div className="vrr-subjects-grid">
                {newspapers.map((news, i) => (
                  <a href={news.link} target="_blank" rel="noreferrer" className="vrr-subject-item" key={i}>
                    <div className={`icon ${news.color}`}><BookIcon /></div>
                    <div className="details">
                      <h4>{news.title}</h4>
                      <span>{news.type}</span>
                    </div>
                    <ExternalLinkIcon style={{width:'16px', color:'#64748B'}} />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* ONLINE RESOURCES (E-LEARNING) - Paginated */}
          <section className="vrr-elearning-section">
            <div className="vrr-section-header">
              <div>
                <h2>Online Learning Resources</h2>
                <p>Enhance your knowledge with open educational portals</p>
              </div>
            </div>

            <div className="vrr-elearning-grid-container">
              <button className="vrr-nav-arrow left" onClick={handlePrevPage}><ChevronRight /></button>
              
              <div className="vrr-elearning-grid">
                {visibleOnlineResources.map((mod, i) => (
                  <div className="vrr-elearning-card" key={i}>
                    <span className={`tag ${mod.tagColor}`}>{mod.tag}</span>
                    <div className="icon"><BookIcon /></div>
                    <h3>{mod.title}</h3>
                    <p>{mod.meta}</p>
                    <a href={mod.link} target="_blank" rel="noreferrer" className="vrr-btn-primary full">Access Portal <ExternalLinkIcon style={{width:'14px'}} /></a>
                  </div>
                ))}
              </div>

              <button className="vrr-nav-arrow right" onClick={handleNextPage}><ChevronRight /></button>
            </div>
            
            <div className="vrr-dots">
              {Array.from({ length: totalOnlinePages }).map((_, idx) => (
                <span 
                  key={idx} 
                  className={idx === onlinePage ? 'active' : ''} 
                  onClick={() => setOnlinePage(idx)}
                />
              ))}
            </div>
          </section>

          {/* KNOWLEDGE TOOLS (Encyclopedias & Dictionaries) */}
          <section className="vrr-tools-section">
             <div className="vrr-section-header">
              <div>
                <h2>Dictionaries & Encyclopedias</h2>
                <p>Essential reference tools for research and learning</p>
              </div>
            </div>

            <div className="vrr-tools-grid">
              {knowledgeTools.map((tool, i) => (
                <div className="vrr-tool-card" key={i}>
                  <div className={`icon-box ${tool.color}`}><BookIcon /></div>
                  <h4>{tool.title}</h4>
                  <p>{tool.desc}</p>
                  <a href={tool.link} target="_blank" rel="noreferrer" className="vrr-link">Open Link <ExternalLinkIcon style={{width:'14px'}} /></a>
                </div>
              ))}
            </div>
          </section>

        </main>
      </div>
      <Footer />
    </>
  );
};

export default VirtualReadingResource;